// extracted by mini-css-extract-plugin
export default {"wrapper":"Fpg9d"};